// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__PAahI","question":"Question_question__3NEd0","description":"Question_description__2T2q2"};